import { render, staticRenderFns } from "./KeyResultDetailDialog.vue?vue&type=template&id=06083320&scoped=true&"
import script from "./KeyResultDetailDialog.vue?vue&type=script&lang=js&"
export * from "./KeyResultDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./KeyResultDetailDialog.vue?vue&type=style&index=0&lang=css&"
import style1 from "./KeyResultDetailDialog.vue?vue&type=style&index=1&id=06083320&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06083320",
  null
  
)

export default component.exports